module.exports = __webpack_public_path__ + "static/media/close.a50190c2.svg";